import React from 'react';
import { EditIcon, PhoneIcon, MailIcon, MapPinIcon, StickyNoteIcon, HashIcon, Trash2Icon, UserPlusIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export interface Customer {
  id: string;
  customerId: string;
  name: string;
  address: string;
  phone: string;
  email?: string;
  notes: string;
  secondaryContactName?: string;
  secondaryContactPhone?: string;
}
interface CustomerCardProps {
  customer: Customer;
  index: number;
  onEdit: (customer: Customer) => void;
  onDelete: (customer: Customer) => void;
  onViewDetail: (customerId: string) => void;
  readOnly?: boolean;
}
export function CustomerCard({
  customer,
  index,
  onEdit,
  onDelete,
  onViewDetail,
  readOnly = false
}: CustomerCardProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    delay: index * 0.05
  }} className="bg-white rounded-xl p-5 shadow-sm border border-stone-100 hover:shadow-md transition-shadow duration-200" data-id="element-475">
      <div className="flex items-start justify-between mb-4" data-id="element-476">
        <div data-id="element-477">
          <h3 className="text-lg font-semibold text-stone-900 cursor-pointer hover:text-teal-600 transition-colors" onClick={() => onViewDetail(customer.id)} data-id="element-478">
            {customer.name}
          </h3>
          <div className="flex items-center gap-1.5 mt-1" data-id="element-479">
            <HashIcon className="w-3.5 h-3.5 text-teal-600" data-id="element-480" />
            <span className="text-sm font-medium text-teal-600" data-id="element-481">
              {customer.customerId}
            </span>
          </div>
        </div>
        {!readOnly && <div className="flex items-center gap-1" data-id="element-482">
            <button onClick={() => onEdit(customer)} className="p-1.5 text-stone-400 hover:text-teal-600 hover:bg-teal-50 rounded-lg transition-all" aria-label="Rediger kunde" data-id="element-483">
              <EditIcon className="w-4 h-4" data-id="element-484" />
            </button>
            <button onClick={() => onDelete(customer)} className="p-1.5 text-stone-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all" aria-label="Slet kunde" data-id="element-485">
              <Trash2Icon className="w-4 h-4" data-id="element-486" />
            </button>
          </div>}
      </div>

      <div className="space-y-3" data-id="element-487">
        {customer.address && <div className="flex items-start gap-3" data-id="element-488">
            <MapPinIcon className="w-4 h-4 text-teal-600 mt-0.5 flex-shrink-0" data-id="element-489" />
            <div data-id="element-490">
              <p className="text-sm text-stone-500" data-id="element-491">Adresse</p>
              <p className="text-stone-900 text-sm" data-id="element-492">{customer.address}</p>
            </div>
          </div>}

        {customer.phone && <div className="flex items-start gap-3" data-id="element-493">
            <PhoneIcon className="w-4 h-4 text-teal-600 mt-0.5 flex-shrink-0" data-id="element-494" />
            <div data-id="element-495">
              <p className="text-sm text-stone-500" data-id="element-496">Telefon</p>
              <p className="text-stone-900 font-medium" data-id="element-497">{customer.phone}</p>
            </div>
          </div>}

        {customer.email && <div className="flex items-start gap-3" data-id="element-498">
            <MailIcon className="w-4 h-4 text-teal-600 mt-0.5 flex-shrink-0" data-id="element-499" />
            <div data-id="element-500">
              <p className="text-sm text-stone-500" data-id="element-501">Email</p>
              <p className="text-stone-900 text-sm" data-id="element-502">{customer.email}</p>
            </div>
          </div>}

        {customer.secondaryContactName && <div className="flex items-start gap-3" data-id="element-503">
            <UserPlusIcon className="w-4 h-4 text-teal-600 mt-0.5 flex-shrink-0" data-id="element-504" />
            <div data-id="element-505">
              <p className="text-sm text-stone-500" data-id="element-506">Ekstra kontakt</p>
              <p className="text-stone-900 text-sm" data-id="element-507">
                {customer.secondaryContactName}
              </p>
              {customer.secondaryContactPhone && <p className="text-stone-500 text-xs" data-id="element-508">
                  {customer.secondaryContactPhone}
                </p>}
            </div>
          </div>}

        {customer.notes && <div className="flex items-start gap-3" data-id="element-509">
            <StickyNoteIcon className="w-4 h-4 text-teal-600 mt-0.5 flex-shrink-0" data-id="element-510" />
            <div data-id="element-511">
              <p className="text-sm text-stone-500" data-id="element-512">Noter</p>
              <p className="text-stone-900 text-sm line-clamp-2" data-id="element-513">
                {customer.notes}
              </p>
            </div>
          </div>}
      </div>
    </motion.article>;
}